import { DynamicDatePickerModel } from "@ng-dynamic-forms/core";
export class DatepickerCheckboxModel extends DynamicDatePickerModel {
    constructor() {
        super(...arguments);
        this.type = 'DATE_CHECK_BOX';
    }
}
